import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';
import LanguageSwitcher from '../LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation();
  const [activeButton, setActiveButton] = useState('Home');
  const buttonNames = ['Home', 'About', 'Works', 'Contact'];

  function handleSelectHeaderItem(buttonName) {
    setActiveButton(buttonName);
    if (buttonName === 'About') {
      const content = document.getElementById('#about');
      if (content) {
        content.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (buttonName === 'Works') {
      const content = document.getElementById('#works');
      if (content) {
        content.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (buttonName === 'Contact') {
      const content = document.getElementById('#contact');
      if (content) {
        content.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  return (
    <>
      <LanguageSwitcher />
      <Styled.Header>
        {buttonNames.map((buttonName) => (
          <button
            key={buttonName}
            className={activeButton === buttonName ? 'active' : ''}
            type="button"
            onClick={() => handleSelectHeaderItem(buttonName)}
          >
            {t(buttonName)}
          </button>
        ))}
      </Styled.Header>
    </>
  );
}
